import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskConsequenceStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
        },
        bold: {
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.primary.main + " !important",
        },
    });
};
